// extracted by mini-css-extract-plugin
export default {"application-form-container":"applicationForm_application-form-container__-4BJB","form":"applicationForm_form__O8AVL"};